import type { PublicSlotKey } from '#packages/apilib';
import type { ExperimentsApi } from './api';

export const ExperimentsApiKey: PublicSlotKey<ExperimentsApi> = {
  name: 'EXPERIMENTS_API',
  public: true,
};
